export const environment = {
  production: false,
  stage: "",
  testing: false,
};

export const api = {
  baseUrl: "https://api.demo.estetistapp.com",
  prefixAuthorization: "Bearer",
  endpoint: {
    login: "/auth/login",
    recovery: "/recovery-password",
    sendEmailRecovery: "/auth/send-email",
    mySalons: "/user/me/salon",
    myCompany: "/user/me/company",
    register: "/auth/company",
    me: "/user/me",
    changePassword: "/auth/change-password",
    refreshToken: "/auth/refresh",
    plans: "/plan/active",
    subPlan: "/company/buy/plan/",
    dashboard: "/user/admin/dashboard",
    userDashboard: "/user/analytics",
    userDashboardLast5: "/user/analytics/last5",
    userDashboardMostActive: "/user/analytics/mostActive",
  },
};
